import Layout from "@/components/layout/index";
import {
  adminRoutes,
  anonymousRoutes,
  hrAdminRoutes,
  hrRoutes,
  studentRoutes,
} from "@/router";

function capitalizeTheFirstLetter(word) {
  if (word != null && word != undefined && word != "") {
    return word.charAt(0).toUpperCase() + word.substr(1);
  } else {
    return word;
  }
}

export function transFormMenuToRoutes(menuTree) {
  let children = [];
  for (let i = 0, len = menuTree.length; i < len; i++) {
    let node = menuTree[i];
    let curNode = {
      path: node.url,
      hidden: node.hidden ? node.hidden : false,
    };
    if (node.children && node.children.length > 0) {
      let subChildren = transFormMenuToRoutes(node.children);
      curNode.name = capitalizeTheFirstLetter(node.code);
      if (node.type == "module") {
        curNode.redirect = "noRedirect";
        curNode.component = Layout;
        curNode.permissions = ["admin"];
      } else {
        curNode.component = dynamicLoadViews(node.componentUrl);
      }
      curNode.meta = {};
      if (node.name) {
        curNode.meta.title = node.name;
      }
      if (node.icon) {
        curNode.meta.icon = node.icon;
      }
      curNode.children = subChildren;
    } else {
      if (node.type == "module") {
        curNode.redirect = node.code;
        curNode.component = Layout;
        curNode.children = [
          {
            path: node.code,
            name: capitalizeTheFirstLetter(node.code),
            component: dynamicLoadViews(node.componentUrl),
            meta: {
              title: node.name,
              icon: node.icon ? node.icon : undefined,
              affix: node.affix ? node.affix : false,
            },
          },
        ];
      } else {
        curNode.name = capitalizeTheFirstLetter(node.code);
        curNode.component = dynamicLoadViews(node.componentUrl);
        curNode.meta = {};
        if (node.name) {
          curNode.meta.title = node.name;
        }
        if (node.icon) {
          curNode.meta.icon = node.icon;
        }
      }
    }
    children.push(curNode);
  }
  return children;
}

function dynamicLoadViews(url) {
  return () => Promise.resolve(require(`@/views/${url}`).default);
}

export async function refreshRoutes(role) {
  let routes = [];
  if (role == "user") {
    routes = studentRoutes;
  } else if (role == "hrAdmin") {
    routes = hrAdminRoutes;
  } else if (role == "hr") {
    routes = hrRoutes;
  } else if (role == "admin") {
    routes = adminRoutes;
  } else {
    routes = anonymousRoutes;
  }
  return routes;
}
